import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { FileImage } from "@/components/FileImage";
import { Loader } from "@/components/Loader";

export default function News() {
  const { t, lang } = useApp();
  const [news, setNews] = useState(null);
  useEffect(() => { api.get("/news").then(({ data }) => setNews(data.news)).catch(() => setNews([])); }, []);
  if (news === null) return <Loader />;

  return (
    <div className="px-6 pt-8 fade-up">
      <h1 className="font-serif-cu text-2xl text-center mb-8">{t("latest_news")}</h1>
      {news.length === 0 ? (
        <p className="text-center text-sm text-[color:var(--cu-muted)] py-10">{t("no_news")}</p>
      ) : (
        <div className="space-y-6">
          {news.map((n) => (
            <article key={n.id} className="cu-card overflow-hidden" data-testid={`news-card-${n.id}`}>
              {n.image_path && <FileImage path={n.image_path} alt={n.title} className="w-full h-44 object-cover" />}
              <div className="p-5">
                <div className="eyebrow mb-2">{n.city || "Caught Up"} · {n.created_at ? new Date(n.created_at).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB") : ""}</div>
                <h2 className="font-serif-cu text-xl mb-3">{n.title}</h2>
                <p className="text-sm text-[color:var(--cu-muted)] leading-relaxed whitespace-pre-line">{n.body}</p>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
